export default {
  search_placeholder: "目的地を検索",
  places_around: "現在地周辺",
  reward_type: "報酬種別",
  pr_method: 'PR方法',
  sns_specify: '指定SNS',
  age_specify: '希望するインフルエンサーの年齢層'
};